<template>
  <div class="app-root">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  let viewportMeta = document.querySelector('meta[name="viewport"]');

  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }

  viewportMeta.content =
    'width=device-width, initial-scale=1.0, maximum-scale=2.0, user-scalable=yes';

  console.log('✅ 应用已启动，使用正常响应式布局，不再整体缩放');
});
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 应用壳固定为视口高度，具体滚动交给各页面布局管理 */
html,
body,
#app {
  overflow: hidden;
}

.app-root {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #f5f7fb;
}

/* 页面容器兜底 */
.app-root .layout,
.app-root .layout-container,
.app-root .main-layout,
.app-root .main-container,
.app-root .page-container,
.app-root .statistics-container {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

/* 防止 flex / grid 子元素撑爆 */
.app-root * {
  box-sizing: border-box;
}

.app-root .t-card,
.app-root .t-card__body,
.app-root .t-table,
.app-root .t-table__content {
  max-width: 100%;
}
</style>
